@if (isMinimal) {
  <search-bar
    [query]="queryFormControl"
    [isCollapsible]="true"
    [isScreenStartPage]="true"
    (queryChanged)="updateSearchQuery($event)"
    (focusChanged)="focusChangeEvent($event)"
    [placeholder]="'start-page.search-placeholder' | translate"
  />
} @else {
  <search-bar
    [query]="queryFormControl"
    [isCollapsible]="false"
    [isGrayBackground]="false"
    [isScreenStartPage]="true"
    (queryChanged)="updateSearchQuery($event)"
    (focusChanged)="focusChangeEvent($event)"
    [placeholder]="'start-page.search-placeholder' | translate"
  />
}

<search-result
  [openSearchResult]="openSearchResult()"
  [searchResults]="searchResults"
/>
